import gsap from 'gsap';
import Component from '../app/component';

export default class extends Component {
  constructor(el) {
    super(el);
    this.data = {
      display: true,
      isScrollTop: true,
      scrollDirection: null
    };
  }

  init() {
    this.scrollSetup();
    this.el.classList.add('top--active');
    if (this.refs.cartLink) {
      this.refs.cartLink.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('cart.toggle'));
      });
    }

    document.addEventListener('top.tweencart', () => {
      this.tweenCartIcon();
    });

    if (this.refs.menuIcon) {
      this.refs.menuIcon.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('mobilemenu.toggle'));
      });
    }

    if (this.refs.closeIcon) {
      this.refs.closeIcon.addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('mobilemenu.toggle'));
      });
    }

    document.addEventListener('mobilemenu.is.active', () => {
      this.el.classList.add('top--mobilemenu');
    });

    document.addEventListener('mobilemenu.isnot.active', () => {
      this.el.classList.remove('top--mobilemenu');
    });
  }

  scrollSetup() {
    this.refs.intersectionLine = document.querySelector('.top-intersection');
    const intObserver = new IntersectionObserver((entries) => {
      this.data.isScrollTop = entries[0].isIntersecting;
    });
    intObserver.observe(this.refs.intersectionLine);

    let scrollTimeout;
    let scrollY = window.scrollY;
    window.addEventListener('scroll', () => {
      const listener = function () {
        const currentScroll = window.scrollY;
        if (currentScroll > scrollY) {
          this.data.scrollDirection = 'down';
        }
        if (currentScroll < scrollY) {
          this.data.scrollDirection = 'up';
        }
        scrollY = currentScroll;
      }.bind(this);
      if (scrollTimeout === undefined) {
        listener();
      }
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        listener();
        scrollTimeout = undefined;
      }, 15);
    });
  }

  displaySet() {
    if (this.data.isScrollTop) {
      this.data.display = true;
    } else if (this.data.scrollDirection === 'down') {
      this.data.display = false;
    } else {
      this.data.display = true;
    }
  }

  tweenCartIcon() {
    if (!this.refs.cartLink) {
      return;
    }
    gsap.fromTo(
      this.refs.cartLink,
      {
        xPercent: -5
      },
      {
        xPercent: 5,
        duration: 0.1,
        yoyo: true,
        repeat: 3,
        ease: 'power4.inOut',
        onStart: () => {
          this.refs.cartLink.style.transition = 'unset';
        },
        onComplete: () => {
          this.refs.cartLink.style.transition = null;
        }
      }
    );
  }

  watchIsScrollTop(value) {
    this.displaySet();
    if (value) {
      this.el.classList.remove('top--scroll');
    } else {
      this.el.classList.add('top--scroll');
    }
  }

  watchScrollDirection() {
    this.displaySet();
  }

  watchDisplay(value) {
    if (value) {
      this.el.classList.remove('top--hide');
    } else {
      this.el.classList.add('top--hide');
    }
  }
}
